import { User } from 'src/domain/user';

export enum MemberRole {
	owner = 'owner',
	member = 'member',
	admin = 'admin'
}

export type Member = {
	id: string;
	role: MemberRole;
	user: User;
	slave: User;
}

export type Group = {
	id: string;
	caption: string;
	description: string;
	event_date: string;
	distribution_date: string;
	private: boolean;
	created_at: string;
	members: number;
	owner: Member;
	distributed: boolean;
	joined_user: Member | null;
	favorite: {
		id: string
	} | null;
}
